export const notificationContent = {
    SOMETHING_WRONG: 'Something went wrong. Please try again later.',
    INVAL_USERNAME: 'Invalid Username.',
    FAILED: 'Failed.',
    SUCCESS: 'Success.',
  }
  